<template>
    <div class="card">
        <div class="card-header">
            <font-awesome-icon :icon="['fas', 'file-alt']" class="mr-1"/>
            Traducciones de Itinerarios
        </div>
        <div class="card-body p-0">
            <ul class="nav nav-tabs px-3 pt-3">
                <li class="nav-item" v-for="tab in tabs" :key="tab.id">
                    <a class="nav-link"
                       :class="{ active: currentTab === tab.id }"
                       href="#"
                       @click.prevent="currentTab = tab.id">
                        {{ tab.label }}
                    </a>
                </li>
            </ul>
            <div class="p-3">
                <itinerary-cotizador v-if="currentTab === 'cotizador'" file="itinerary"/>
                <itinerary-paquete v-else-if="currentTab === 'paquete'"/>
                <itinerary-stela v-else-if="currentTab === 'stela'"/>
            </div>
        </div>
    </div>
</template>

<script>
  import ItineraryCotizador from './ItineraryCotizador'
  import ItineraryPaquete from './ItineraryPaquete'
  import ItineraryStela from './ItineraryStela'

  export default {
    components: { ItineraryCotizador, ItineraryPaquete, ItineraryStela },
    data () {
      return {
        currentTab: 'cotizador',
        tabs: [
          { id: 'cotizador', label: 'Itinerario Cotizador' },
          { id: 'paquete', label: 'Itinerario Paquete' },
          { id: 'stela', label: 'Itinerario Stela' }
        ]
      }
    }
  }
</script>
